import { AddCircleSharp, RemoveCircleSharp, ArrowForwardIosSharp, ArrowBackIosSharp } from "@mui/icons-material";
import React, { useMemo, useCallback, useState } from "react";
import { Slider, Stack, Tooltip } from "@mui/material";
import debounce from "lodash/debounce";

const Slide = ({ onChange,
                 value: initialValue,
                 min = 0,
                 max = 100,
                 step=1,
                 width = 150,
                 StartIcon = null,
                 EndIcon = null,
                 iconColor='#000',
                 debounceDelay = 300,
                 fontColor='#222',
                 postfix='',
                 prefix='',
                 tooltip=''
}) => {
  const [sliderValue, setSliderValue] = useState(initialValue);

  const marks = useMemo(() => {
    return [
      { value: min, label: `${prefix}${min}${postfix}`, fontColor: fontColor },
      { value: max, label: `${prefix}${max}${postfix}`, color: fontColor },
    ];
  }, [min, max]);

  const debouncedOnChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, debounceDelay),
    [onChange, debounceDelay]
  );

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
    debouncedOnChange(newValue);
  };

  return (
    <Tooltip title={tooltip}>
        <Stack space={4} direction={"row"}>
            {StartIcon && <StartIcon sx={{ color: iconColor }} />}
            <Slider
                value={sliderValue}
                marks={marks}
                onChange={handleSliderChange}
                aria-labelledby="window-size-slider"
                valueLabelDisplay="auto"
                min={min}
                max={max}
                step={step}
                style={{
                    width: width,
                    marginLeft: '5px',
                    marginRight: '5px',

              }}
                sx={{'& .MuiSlider-markLabel': { color: fontColor, fontFamily: 'var(--font-title)', fontWeight: '600' }}}
            />
            {EndIcon && <EndIcon sx={{ color: iconColor }} />}
        </Stack>
    </Tooltip>
  );
};

export default Slide;